import { Component } from '@theme/component';

export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  async connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) {
        source.src = videoSource;
      }
    }

    videoElement.muted = true;
    videoElement.defaultMuted = true;
    videoElement.loop = true;
    videoElement.autoplay = true;
    videoElement.playsInline = true;

    videoElement.setAttribute('muted', '');
    videoElement.setAttribute('autoplay', '');
    videoElement.setAttribute('loop', '');
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('webkit-playsinline', '');

    videoElement.load();

    const playVideo = () => {
      const promise = videoElement.play();

      if (promise !== undefined) {
        promise.catch(() => {
          document.addEventListener(
            'touchstart',
            () => videoElement.play(),
            { once: true }
          );
        });
      }
    };

    if (videoElement.readyState >= 2) {
      playVideo();
    } else {
      videoElement.addEventListener('canplay', playVideo, { once: true });
    }
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define(
    'video-background-component',
    VideoBackgroundComponent
  );
}